export const FacebookLoginAppId = "372671279578296"
export const GoogleLoginClientId = "1009548039438-4g5foflb3b8pkfso2bdutlbj5s7tvfrg.apps.googleusercontent.com"
